export function alphaKeysOnly(event): boolean {
	const charCode = event.which ? event.which : event.keyCode;

	if (charCode >= 48 && charCode <= 57) {
		// numeric keys
		return false;
	}

	if (charCode >= 33 && charCode <= 38) {
		// special keys
		return false;
	}

	if (charCode >= 40 && charCode <= 44) {
		// special keys
		return false;
	}

	if (charCode >= 46 && charCode <= 47) {
		// special keys
		return false;
	}

	if (charCode >= 58 && charCode <= 64) {
		// special keys
		return false;
	}

	if (charCode >= 91 && charCode <= 95) {
		// special keys
		return false;
	}

	if (charCode >= 123 && charCode <= 126) {
		// special keys
		return false;
	}

	if (charCode >= 161 && charCode <= 191) {
		// special keys
		return false;
	}

	if (charCode === 8217) {
		// special keys
		return false;
	}

	return true;
}
